import {useEffect, useState} from 'react';

const autoShowPopupType = [`show-campaign-popup`];

/**
 * Custom hook to monitor a specific URL parameter and return a boolean
 * indicating whether the popup should be shown.
 *
 * @param paramName - The name of the URL parameter to monitor.
 * @returns A boolean indicating whether the popup should be shown.
 */
export const useAutoShowPopup = (paramName: string): boolean => {
  const [autoShowPopup, setAutoPopupTypes] = useState<boolean>(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paramValue = params.get(`popupType`);
    if (paramValue) setAutoPopupTypes(autoShowPopupType.includes(paramValue));
  }, [paramName]);

  return autoShowPopup;
};
